import { Box, Skeleton, Stack } from "@mui/material";

export const ProductsListSectionLoading = () => {
  return (
    <Stack gap={4}>
      {/* Title */}
      <Skeleton variant="text" height={40} />

      {/* Configurator name and label */}
      <Stack gap={1}>
        <Skeleton variant="rounded" height={40} />
        <Stack direction="row" gap={1} alignItems="center">
          <Skeleton variant="rounded" height={24} sx={{ borderRadius: 4 }} />
          <Skeleton variant="rounded" height={24} sx={{ borderRadius: 4 }} />
          <Skeleton variant="rounded" height={24} sx={{ borderRadius: 4 }} />
        </Stack>
      </Stack>

      {/* Products */}
      <Stack gap={2}>
        <Skeleton variant="text" height={14} />
        <Stack gap={1}>
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} variant="rounded" height={44} />
          ))}
          <Box>
            <Skeleton variant="rounded" height={36} />
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};
